import type { EduCourse } from '@common/types/edu-course.type';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

const EduCoursesActions = createActionGroup({
    source: 'EduCourses/Collection/API',
    events: {
        'Load Collection Request': emptyProps(),
        'Load Collection Success': props<{ courses: EduCourse[] }>(),
        'Load Collection Failure': props<{ error: string }>(),
    },
});

export default EduCoursesActions;
